import {
  PermissionsPromptAppIcon,
  PermissionsPromptContainer,
  PermissionsPromptContentContainer,
  PermissionsPromptHexagon,
  PermissionsPromptHexagonStroke,
  PermissionsPromptText,
  PermissionsPromptTitle,
} from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const PermissionsPrompt = {
  AppIcon: PermissionsPromptAppIcon,
  Container: PermissionsPromptContainer,
  ContentContainer: PermissionsPromptContentContainer,
  Hexagon: PermissionsPromptHexagon,
  HexagonStroke: PermissionsPromptHexagonStroke,
  Title: PermissionsPromptTitle,
  Text: PermissionsPromptText,
};
